import React, { useEffect, useState } from "react";
import "src/components/Registration/registration.scss";
import { useSelector } from "react-redux";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { MAX_TEXT_FIELD_SIZE } from "src/resources/constant";
import { getFieldName, isArabic } from "src/utils/helpers";
import { IEmirate } from "src/redux/interfaces/ILookup_1";
import { Dropdown } from "primereact/dropdown";
const CDProfile = () => {
  const { t } = useTranslation(["common", "user", "registration"]);

  const emirateOptions = useSelector((state: any) =>
    state.lookup.emiratesOptions.filter(
      (em: IEmirate) => em.emirateCode === "AUH"
    )
  );
  const citiesOptions = useSelector((state: any) => state.lookup.citiesOptions);
  const language = useSelector((state: any) => state.lookup.language);

  const { BMCData } = useSelector((state: any) => state.bMCProfile);

  return (
    <div className={`registration-form-wrapper ps-0`}>
      <div className={`registration-form view-profile-form`}>
        <form>
          <div className="section">
            <div className="form-group-row">
              <div className="form-group wide-form-group">
                <label htmlFor="name">{t("name")}</label>
                <input
                  type="text"
                  value={BMCData.name}
                  id="name"
                  name="name"
                  disabled
                />
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label htmlFor="officePhoneNumber">{t("phoneNumber")}</label>
                <div className="form-group input-with-label">
                  <span className="ltr">+971</span>
                  <input
                    value={BMCData.phoneNumber}
                    type="tel"
                    id="officePhoneNumber"
                    name="officePhoneNumber"
                    maxLength={MAX_TEXT_FIELD_SIZE}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="email">{t("Email")}</label>
                <input
                  value={BMCData.email}
                  type="text"
                  id="email"
                  name="email"
                  maxLength={MAX_TEXT_FIELD_SIZE}
                  disabled
                  title="Email must be a valid email address"
                />
              </div>
              <div className="form-group">
                <label htmlFor="city">{t("cities")}</label>
                <input
                  id="city"
                  value={isArabic()? BMCData.cityArabicName : BMCData.cityEnglishName }
                  name="city"
                  disabled
                />
              </div>
              <div className="form-group">
                <label htmlFor="emirate">{t("emirate")}</label>
                <Dropdown
                  id="emirate"
                  value={emirateOptions[0]?.emirateId}
                  name="emirate"
                  options={emirateOptions}
                  optionLabel={getFieldName(language)}
                  optionValue="emirateId"
                  placeholder={t("selectAnEmirate")}
                  disabled
                  className={"disabled"}
                />
              </div>
              <div className="form-group">
                <label htmlFor="name">{t("userName")}</label>
                <input
                  type="text"
                  value={BMCData.userName}
                  id="name"
                  name="name"
                  disabled
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CDProfile;
